<template>
  <v-container>
    <!-- 検索エリア -->
    <v-form
      ref="searchForm"
      v-model="valid"
      lazy-validation
    >
      <v-row>
        <!-- <v-col cols="3">
          <v-radio-group 
            v-model="searchCondition.listType"
            dense
            row
            :disabled="loading"
            @change="search()"
          >
            <v-radio
              label="会員"
              :value="0"
              checked
            ></v-radio>
            <v-radio
              label="非会員"
              :value="1"
            ></v-radio>
            <v-radio
              label="閉鎖廃止"
              :value="2"
            ></v-radio>
          </v-radio-group>
        </v-col> -->
        <v-col cols="10">
          <!-- <v-layout wrap> -->
          <v-row>
            <v-col cols="2">
              <!-- <v-checkbox 
                  class="mr-3" label="会員企業" 
                  v-model="searchCondition.divCompany"
                  :true-value="1"   :false-value="0"
                  :disabled="loading"
                  @change="search()"
                  dense /> -->
              <v-select
                  label="会員企業"
                  :items="divosionCompanyList"
                  dense
                  v-model="searchCondition.divCompany"
                  :readonly="attribute == 1"
                  :disabled="loading"
                  v-on:change="search()"
              ></v-select>
            </v-col>
            <v-col cols="2">
              <!-- <v-checkbox 
                  class="mr-3" label="事業所会員Ⅰ" 
                  v-model="searchCondition.divIndustry1" 
                  :true-value="1"   :false-value="0"
                  :disabled="loading"
                  @change="search()"
                  dense /> -->
              <v-select
                  label="事業所会員Ⅰ"
                  :items="divosionList"
                  dense
                  v-model="searchCondition.divIndustry1"
                  :readonly="attribute == 1"
                  :disabled="loading"
                  v-on:change="search()"
              ></v-select>
            </v-col>
            <v-col cols="2">
              <!-- <v-checkbox 
                  class="mr-3" label="事業所会員Ⅱ" 
                  v-model="searchCondition.divIndustry2" 
                  :true-value="1"   :false-value="0"
                  :disabled="loading"
                  @change="search()"
                  dense /> -->
              <v-select
                  label="事業所会員Ⅱ"
                  :items="divosionList"
                  dense
                  v-model="searchCondition.divIndustry2"
                  :readonly="attribute == 1"
                  :disabled="loading"
                  v-on:change="search()"
              ></v-select>
            </v-col>
            <v-col cols="2">
              <!-- <v-checkbox 
                  class="mr-3" label="事業所会員Ⅲ" 
                  v-model="searchCondition.divIndustry3" 
                  :true-value="1"   :false-value="0"
                  :disabled="loading"
                  @change="search()"
                  dense /> -->
              <v-select
                  label="事業所会員Ⅲ"
                  :items="divosionList"
                  dense
                  v-model="searchCondition.divIndustry3"
                  :readonly="attribute == 1"
                  :disabled="loading"
                  v-on:change="search()"
              ></v-select>
            </v-col>
            <v-col cols="2">
              <!-- <v-checkbox 
                  class="mr-3" label="賛助" 
                  v-model="searchCondition.divSupporter" 
                  :true-value="1"   :false-value="0"
                  :disabled="loading"
                  @change="search()"
                  dense /> -->
              <v-select
                  label="賛助"
                  :items="divosionList"
                  dense
                  v-model="searchCondition.divSupporter"
                  :readonly="attribute == 1"
                  :disabled="loading"
                  v-on:change="search()"
              ></v-select>
             </v-col>
            <v-col cols="2">
              <!-- <v-checkbox 
                  label="冷事" 
                  v-model="searchCondition.divFrozen" 
                  :true-value="1"   :false-value="0"
                  :disabled="loading"
                  @change="search()"
                  dense /> -->
              <v-select
                  label="冷事"
                  :items="divosionList"
                  dense
                  v-model="searchCondition.divFrozen"
                  :readonly="attribute == 1"
                  :disabled="loading"
                  v-on:change="search()"
              ></v-select>
            </v-col>
          </v-row>
          <!-- </v-layout> -->
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3">
          <v-autocomplete label="都道府県" 
                v-model="searchCondition.prefIdList" 
                :items="prefList" 
                multiple
                dense 
                :disabled="loading"
                :loading="loading"
                @change="search()"
          ></v-autocomplete>
        </v-col>
        <v-col cols="5">
            <v-text-field
              label="検索"
              v-model="searchCondition.searchString"
              dense
              :readonly="false"
              :clearable="false"
              :rules="[maxLength(50)]"
              :loading="loading"
            ></v-text-field>
        </v-col>
<!-- 
        <v-spacer></v-spacer>
        <v-col cols="2">
          <v-btn class="btn_font primary" width="120" v-on:click="search()" :disabled="loading" ><v-icon :small="true">mdi-magnify</v-icon>検索</v-btn>
        </v-col>
-->
      </v-row>
    </v-form>
    <!-- 会員一覧/選択エリア -->
    <v-form
      ref="form"
      v-model="valid"
      lazy-validation
    >
      <v-row class="mb-n7">
        <v-col v-if="!loading" cols="auto">
          <input :disabled="filterItems.length <= 0" type='checkbox' id="select-all-checkbox" v-model="selectAll" /><label for="select-all-checkbox">すべて選択</label>
        </v-col>
        <v-col v-else cols="auto">
          <input :disabled="true" type='checkbox' :value="false" /><label>すべて選択</label>
        </v-col>
        <v-col cols="auto">
        {{ filterItemsMemberCnt }}件の会員が見つかりました
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="12" md="12" lg="12">
          <v-data-table
            ref="ref"
            :search="searchCondition.searchString"
            :headers="comHeaders"
            :items="memberList"
            :loading="loading"
            :dense='true'
            :items-per-page="10"
            :mobile-breakpoint="0"
            :disable-pagination='true'
            :hide-default-footer='true'
            :fixed-header='true'
            disable-sort
            locale="ja-jp"
            loading-text="読込中"
            no-data-text="データがありません。"
            class="table-border"
            height="calc(100vh - 500px)"
          >
            <template v-slot:item="{ item }">
              <tr :key="item.memberNo">
                <td class="center">
                  <input type='checkbox' v-model="innerSelectedList" :value="item" />
                </td>
                <td v-if="searchType != ''" class="center">
                  {{item.survStatus != 0 ? '依頼済み' : ''}}
                </td>
                <td class="center">
                  {{item.memberNo}}
                </td>
                <td class="left">
                  {{item.companyName}}
                </td>
                <td class="left">
                  {{item.officeName}}
                </td>
                <td class="left">
                  {{item.toList}}
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-col>
      </v-row>

      <!-- アクション -->
      <v-row>
        <v-col cols="6" sm="6" md="6" lg="6" class="text-center">
          <v-btn class="btn_font primary" width="120" v-on:click="registData()" :disabled="loading" >確定</v-btn>
        </v-col>
        <v-col cols="6" sm="6" md="6" lg="6" class="text-center">
          <v-btn class="btn_font primary" width="120" v-on:click="cancel()" :disabled="loading" >キャンセル</v-btn>
        </v-col>
      </v-row>
    </v-form>

  </v-container>
</template>

<script>
import Mixin from "../mixins/const.js";
import Debug from '../Lib/Debug'
import Message from "../Lib/Message";

import Member from "../model/member";

export default {
  mixins: [Mixin],

  components: {
  },

  props: [
    'selectedList',
    'searchType',
    'targetDate',
  ],

  data: () => ({
    valid : true,
    loading: false,

    show: true,

    // 検索条件
    searchCondition: {
      listType: 0,
      divCompany: -1,
      divIndustry1: -1,
      divIndustry2: -1,
      divIndustry3: -1,
      divSupporter: -1,
      divFrozen: -1,
      prefIdList: [],
      searchType: "",
      targetDate: "",
      searchString: "",
    },

    // 事業所会員一覧
    memberList: [],

    // テーブルヘッダー
    headers: [
        { text: '選択', align: 'center', sortable: true, value: 'check', width: "5%" },
        { text: '会員番号', align: 'center', sortable: true, value: 'memberNo', width: "8%" },
        { text: '会社名', align: 'center', sortable: true, value: 'companyName', width: "20%" },
        { text: '事業所名', align: 'center', sortable: true, value: 'officeName', width: "20%" },
        { text: '宛先', align: 'center', sortable: true, value: 'toList', width: "47%" },
    ],
    headersSurv: [
        { text: '選択', align: 'center', sortable: true, value: 'check', width: "5%" },
        { text: '依頼状況', align: 'center', sortable: true, value: 'survStatus', width: "7%" },
        { text: '会員番号', align: 'center', sortable: true, value: 'memberNo', width: "8%" },
        { text: '会社名', align: 'center', sortable: true, value: 'companyName', width: "20%" },
        { text: '事業所名', align: 'center', sortable: true, value: 'officeName', width: "20%" },
        { text: '宛先', align: 'center', sortable: true, value: 'toList', width: "40%" },
    ],

    innerSelectedList: [],
  }),

  // ライフサイクルフック
  created: function () {
    // 検索種別：実態調査、電力調査、冷媒調査
    this.searchCondition.searchType = this.searchType;
    this.searchCondition.targetDate = this.targetDate;
    this.search();
  },

  mounted: async function () {

  },

  methods: {
    /** 表示更新 */
    async loadList() {
      Debug.log('function[loadList]');
      this.loading = true;

      try {
        const res = await Member.selectMemberList(this.searchCondition);
        Debug.log(res.data);
        //if(res.data.length > 0) {
          this.memberList = res.data;
        //}
      } catch (error) {
        Message.err(error, "事業所会員一覧を取得できませんでした");
      }
      Debug.log(this.memberList);

      this.loading = false;
    },

    search() {
      Debug.log("function[search]");
      this.loadList();
    },

    /** 回答依頼メール送信 */
    registData() {
      if (!confirm("確定します。よろしいですか？")) return;
      this.$emit('registEvt', this.innerSelectedList);
      this.close();
    },

    // キャンセル
    cancel() {
      if (!confirm("変更をキャンセルします。よろしいですか？")) return;
      this.close();
    },

    close() {
      this.$emit("closeEvt");
    },
  },

  computed: {
    // テーブルヘッダー
    comHeaders() {
      if(this.searchType != "") {
        // 調査
        return this.headersSurv;
      } else {
        // その他
        return this.headers;
      }
    },

    filterItems() {
      if (this.memberList.length > 0) {
        return this.$refs.ref.$children[0].filteredItems;
      } else {
        return [];
      }
    },

    // 選択リストにフィルターアイテムが含まれている
    isIncludesSelectedList() {
      let cnt = 0;
      this.filterItems.forEach(function (item) {
        if(this.innerSelectedList.some(select => select.memberNo === item.memberNo)){
          cnt++;
        }
      }.bind(this));

      Debug.log2('this.innerSelectedList:', this.innerSelectedList);
      Debug.log2('this.filterItems:', this.filterItems);
      Debug.log2('isIncludesSelectedList:', cnt);

      return (cnt > 0) && (this.filterItems.length === cnt);
    },

    selectAll: {
      get: function () {
        Debug.log('selectAll get');
        return this.filterItems ? ((this.filterItems.length > 0) && (this.isIncludesSelectedList)) : false;
      },
      set: function (memberNo) {
        let tmpSelectedList = [];
        this.filterItems.forEach(function (memberList) {
          tmpSelectedList.push(memberList);
        });
        if (memberNo) {
          // すべて選択の場合
          Debug.log('selectAll set');
          // this.filterItems.forEach(function (memberList) {
          //     //if(memberList.survStatus == 0) {
          //       tmpSelectedList.push(memberList);
          //     //}
          //   });
          let tmpInnerSelectedList = Array.from(new Set(this.innerSelectedList.concat(tmpSelectedList)));
          this.innerSelectedList = tmpInnerSelectedList.filter((element, index, self) => 
                                      self.findIndex(e => 
                                        e.memberNo === element.memberNo
                                      ) === index
                                    );
        } else {
          // すべて選択解除の場合
          Debug.log('selectAll false');
          Debug.log2('this.innerSelectedList',this.innerSelectedList);
          Debug.log2('tmpSelectedList',tmpSelectedList);
          let tmpInnerSelectedList = this.innerSelectedList;
          // 表示されているすべてのアイテムを削除
          tmpSelectedList.forEach(function (d) {
            tmpInnerSelectedList = tmpInnerSelectedList.filter(function(b){
                                        return b.memberNo !== d.memberNo
                                      });
            
          });

          this.innerSelectedList = tmpInnerSelectedList;
        }
      }
    },

    // 検索結果会員・協会件数
    filterItemsMemberCnt() {
      if (this.memberList.length > 0) {
        let tmpItems = this.$refs.ref.$children[0].filteredItems;
        const cntList = Array.from(new Set(tmpItems.map((item) => {
            return item.memberNo;
          })
        ));
        return cntList.length;
      } else {
        return 0;
      }
    },
  },

  watch: {
    selectedList: {
      immediate: true,
      handler(value) {
        this.innerSelectedList = value;
      },
    },
  },
};
</script>

<style scoped>
.v-input--radio-group {
  margin: 0;
}

.disablecolor {
  background: #bbbbbb;
}

</style>
